export default {
  home: {
    hello: 'Hello',
    newMessage: 'You have a new message!',
    newMessages: 'You have new messages!',
    digitalHealthConsultationTitle: 'Digital Health Consultation',
    viewBookingDetails: 'View booking details',
    healthPlanTitle: 'Direct access to your individualised health plan',
    digDeeperTitle: 'Dig deeper',
    discoverMore: 'Discover more',
    podcastTitle: "Don't miss our podcast - Gynpodden",
    podcastDescription:
      "In Gynpodden we talk about the female body and gender equality from a scientific perspective. Personal stories are interwoven with topics where we invite Sweden's leading experts to spread knowledge together.",
    allPodcastEpisodes: 'All our podcast episodes',
    messageQuestion: 'Do you have questions about your health or health plan?',
    messageTitle: 'Message EsterCare Health Team',
    messageDescription:
      'Do you have questions about your health or health plan? Message your EsterCare health team and get individualised guidance when you need it. No question is too small – we are here to support you. Our health team usually replies within 24 hours on business days.',
  },
  healthCall: {
    callsRemaining: 'You have {{count}}/{{total}} digital health consultations remaining.',
    step1Title: 'Book a health consultation',
    step1Description:
      'Start by filling in your details, then choose a time that suits you. Once the booking is complete, a confirmation will be sent to you via e-mail.',
    goToCalendar: 'Select time for health consultation',
    journalText:
      'The health call is booked in our journal system, where your information is handled under the Swedish Patient Data Act (Patientdatalagen). Your employer never has access to it.',
    journalCheckbox: 'I have read the information and want to book the health call.',
    journalConsentError: 'Something went wrong when saving your approval. Please try again later.',
    step2Title: 'Download our app',
    step2Description:
      'Search for "EsterCare" in the App Store or Google Play, or scan the QR code to download the app directly:',
    step3Title: 'Log in and attend your consultation',
    step3Description:
      'Simply log in to our app using your BankID and attend the consultation through the app. You can join the meeting 5 minutes before your scheduled time.',
    completedTitle: '{{total}} of {{total}} health consultations completed',
    completedDescription:
      'You have completed your three health consultations funded by {{organisationName}}. You will receive access to three more consultations next year.',
    howToPerform: 'How do I attend my health consultation?',
    modalTitle: 'Your details',
    modalDescription: "Please provide your details and we'll send you a booking confirmation shortly.",
    errorMessage: 'Something went wrong. Please check that your information is correct.',
    personalNumber: 'Personal number',
    phoneNumber: 'Telephone number',
    phoneNumberPlaceholder: '+4670XXXXXXX',
    personalNumberPlaceholder: 'YYYYMMDD-XXXX',
    personalNumberValidationError: 'Enter in format YYYYMMDD-XXXX',
    personalNumberRequired: 'Personal number required',
    phoneNumberValidationError: 'Invalid phone number format. Must be in format: +46701234567',
    phoneNumberRequired: 'Phone number required',
    bookingInfo: 'Digital video meeting - log in to the EsterCare app to conduct the meeting',
    cancelWarning:
      'If you cancel your health consultation within 24 hours of the appointment time, it will count as a completed health consultation.',
    cancelError: 'Failed to cancel the health consultation. Please try again or contact support.',
    bookingDetails: 'Your booking details',
    cancelBooking: 'Cancel your booking',
    cancelConfirmation: 'Are you sure you want to cancel?',
    todayAt: 'Today at',
    tomorrowAt: 'Tomorrow at',
    time: 'at',
    calendarTitle: 'Digital Health Consultation',
    calendarDescription:
      'Book a video call with one of our midwives to receive personal advice and support regarding your health.',
    confirmBooking: 'Confirm booking',
    fullyBooked: 'Fully booked',
    loading: 'Loading timeslots...',
    error: 'An error occurred',
    timeSlotErrorMessage: 'Could not load available timeslots. Please try again.',
    duration: '15 min',
    meetingType: 'Digital video call',
    confirmTitle: 'Confirm your booking',
    cancellationPolicy:
      'You may cancel or reschedule your meeting up to 24 hours before the scheduled time. Any meeting not cancelled within this timeframe will be counted as one of the three meetings included in your plan.',
    bookingError: 'Failed to book the health consultation. Please try again.',
    timeslotExpired: 'Timeslot no longer available',
    timeslotExpiredMessage:
      'The selected timeslot has passed or is no longer available for booking. Please select a new time.',
    timeslotExpiredButton: 'Select new time',
    cancelSuccess: 'Your health consultation has been successfully cancelled.',
    cancelSuccessTitle: 'Booking cancelled',
    cancelSuccessMessage: 'Your health consultation has been successfully cancelled.',
    notAvailableTitle: 'Service Not Available',
    notAvailableMessage: 'Health calls are currently not available for users in this market.',
    returnToHome: 'Return to Home',
  },
  screening: {
    basedOnDate: 'Based on your screening from {{date}}',
    recommendationsHelperText:
      'Need a little refresher? Here you can read through the self-care advice we gave you in your health plan.',
    showRecommendations: 'Show your recommendations',
    hideRecommendations: 'Hide your recommendations',
    followUpDescription:
      "It's time to follow up to see how the past few months have been and how you're feeling today.\n\nYour answers help us give you more relevant recommendations going forward and update the graphs of your wellbeing so you can track how your health develops over time.\n\nThe follow-up takes approximately 5 minutes to complete.",
    standardDescription:
      "By answering screening questions, we help you identify symptoms affecting your health. You'll receive a personalised analysis and a practical health plan to help you take the next step towards better wellbeing. Your responses are confidential and will not be shared with {{organisationName}}.\n\nThe screening takes approximately 15 minutes to complete.",
    invitedFollowUpDescription:
      "It's now time to follow up on how you're feeling based on the responses you provided in the screening in {{date}}.\n\nBy answering the follow-up questions, we can determine whether your symptoms have improved or not, and provide you with updated advice accordingly. Your responses are confidential.\n\nThe follow-up takes approximately 2 minutes to complete.",
    invitedStandardDescription:
      "By answering screening questions, we help you identify symptoms affecting your health. You'll receive a personalised analysis and a practical health plan to help you take the next step towards better wellbeing. Your responses are confidential.\n\nThe screening takes approximately 15 minutes to complete.",

    submitTitle: 'Time to submit!',
    submitButton: 'Submit',
    submitPreviousError:
      'Unable to return to the previous question. Please try again or contact support at support@estercare.com',
    submitError: 'Unable to submit the screening. Please try again or contact support at support@estercare.com',
    errorTitle: 'Something went wrong!',
    nextQuestionError:
      'Unable to proceed to the next question. Please try again or contact support at support@estercare.com',
    previousQuestionError:
      'Unable to return to the previous question. Please try again or contact support at support@estercare.com',
    generalError: 'Something went wrong. Please try again!',
    continueButton: 'Continue',
    nextQuestionButton: 'Next question',
    standardTitle: "Screening Service for Women's Health",
    standardNotStartedPage: 'Begin screening',
    standardContinuePage: 'Continue with screening',
    standardNotStartedButton: 'Begin screening',
    standardContinueButton: 'Continue with screening',
    standardCompletedTitle: 'Your screening has been processed!',
    standardCompletedDescription: 'View your personal analysis and health plan under Your Health Plan.',
    standardCompletedButton: 'Go to Your Health Plan',
    standardCompletedPending: 'Your screening is being processed',
    standardPendingDescription:
      'Your screening has been submitted and is currently being processed by our experts. Within 3 working days, you will receive an email when your personal analysis and health plan are ready.',
    consentAgree:
      'I consent to EsterCare processing my health data for screening, health plan, follow-up and messages under the',
    dataProcessing: 'data protection policy',
    consentWithdraw: '. I can withdraw my consent at any time.',
    journalTitle: 'Save your screening ahead of a care visit (optional).',
    journalText:
      "We save a summary of your screening in our journal system, so the doctor can read it if you later book a doctor's appointment with us. This requires your personal identity number. The summary is handled under the Swedish Patient Data Act (Patientdatalagen) and your employer never has access to it.",
    journalCheckbox: 'Yes, save a summary of my screening in the journal system.',
    consentError: 'Something went wrong when saving your consent. Please try again later.',
    followUpTitle: 'Follow-up of your screening',
    followUpNotStartedPage: 'Begin follow-up',
    followUpContinuePage: 'Continue with follow-up',
    followUpNotStartedButton: 'Begin follow-up',
    followUpContinueButton: 'Continue with follow-up',
    followUpCompletedPage: 'Follow-up',
    followUpCompletedTitle: 'Your follow-up has been processed!',
    followUpCompletedDescription: 'Access your personal analysis and health plan under Your Health Plan.',
    followUpCompletedButton: 'Go to Your Health Plan',
    followUpPendingPage: 'Your follow-up is being processed',
    followUpPendingTitle: 'Your follow-up is being processed',
    followUpPendingDescription:
      "Your follow-up has been submitted and is currently being reviewed by our experts. Within 3 working days, you'll receive an email when your personal analysis and health plan have been updated.",
    checkInTitle: 'Hello {{firstName}}!',
    checkInDescription: 'You completed a screening in {{date}}. How have things been since then?',
    outcomesTitle: 'Your outcomes from your screening on {{date}}',
    outcomesDescription:
      'In your screening, the following areas were identified — these are the ones we want to follow up on today.',
    checkInNotStartedPage: 'Check-in',
    checkInNotStartedButton: 'Start check-in',
    checkInContinuePage: 'Check-in',
    checkInContinueButton: 'Continue check-in',
    bookHealthCallPage: 'Health consultation',
    bookHealthCallTitle: 'Would you like to book a health consultation?',
    bookHealthCallDescription:
      "In a health consultation, you'll meet with a midwife digitally to review your screening results. You can also ask questions about your wellbeing and, if needed, schedule a follow-up care appointment.",
    bookHealthCallButton: 'Book health consultation',
    under15Warning: 'You will gain access to the screening from the year you turn 15.',
    maleUserTitle: 'This screening is available for female users.',
    maleUserDescription: 'You have specified that your biological sex is male.',
    giftHeading: "Gift a women's health screening",
    giftDescription:
      "Our screening is designed to give women personal insights and concrete recommendations about their health.\n\nAs a man, you have the opportunity to gift a screening with an accompanying health plan to someone you care about – for example a partner, sister, daughter or friend.\n\nIt only takes a minute to send an invitation and can make a real difference to someone's health.",
    giftButton: 'Gift a screening',
    giftModalTitle: 'Gift a screening',
    maleScreeningTitle: 'Screening',
    giftModalDescription:
      "Send an invitation to EsterCare's health portal.\nThe account is completely separate from yours.",
    giftFirstName: 'First name',
    giftLastName: 'Last name',
    giftEmail: 'Email',
    giftSendButton: 'Send invitation',
    giftSuccessTitle: 'Invitation sent!',
    giftSuccessDescription: 'An invitation has been sent to {{email}}.',
    giftAlreadyInvited: 'You have already sent an invitation.',
    giftError: 'Something went wrong when sending the invitation. Please try again.',
    renewScreeningTitle: "It's time to renew your screening!",
    renewScreeningDescription:
      'A year has passed since you completed your last screening. To continue providing you with relevant advice and recommendations, we encourage you to complete the screening again.',
    renewScreeningButton: 'Start screening',
    previousRating: 'Last time, you rated this {{rating}} out of {{max}}.',
  },
  yourHealth: {
    wellbeing: 'Wellbeing',
    overallWellbeingScore: 'Overall Wellbeing Score',
    symptomTrendsTitle: 'Symptom trends over time',
    symptomTrendsDescription:
      'Track how individual symptoms evolve across assessments to better understand changes in your wellbeing over time.',
    topSymptomsOverview: 'Top Symptoms Overview',
    graphsBreakdownTitle: 'Your health in detail',
    graphsBreakdownDescription: 'See how your symptoms and wellbeing develop and affect your everyday life.',
    severity: 'Severity',
    everydayImpact: 'Everyday life impact',
    healthPlanTab: 'Health Plan',
    healthProgressTab: 'Health Over Time',
    noScreeningDescription:
      'Here you will find your personal health plan.\nIn the health plan, we help you identify potential problem areas, prevent future issues and strengthen your health.\nTo create it, you first need to complete our screening.',
    pendingMessage:
      "Once you've completed your screening and we've analysed your answers, your personalised health plan will appear here. The analysis can take up to 3 working days.",
    promptStartTitle: 'Time to do your health screening',
    promptStartDescription:
      'By answering the screening questions, we help you identify issues that affect your health. You will receive a personal analysis and a practical health plan.',
    promptStartButton: 'Start screening',
    promptContinueTitle: 'Complete your health screening',
    promptContinueDescription: 'You have started your screening. Complete it to get your personalised health plan.',
    promptContinueButton: 'Continue screening',
    promptFollowUpStartTitle: 'Time for your follow-up',
    promptFollowUpStartDescription:
      'It is now time to follow up on how you are feeling based on your previous answers. Through the follow-up, we can see if your symptoms have improved.',
    promptFollowUpStartButton: 'Start follow-up',
    promptFollowUpContinueTitle: 'Complete your follow-up',
    promptFollowUpContinueDescription: 'You have started your follow-up. Complete it to get updated recommendations.',
    promptFollowUpContinueButton: 'Continue follow-up',
    healthPlanSummary: 'Your health plan at a glance',
    helloGreeting: 'Hello, {{firstName}}!',
    healthPlanCardsTitle: 'Your recommendations',
    healthPlanCardsDescription:
      'Advice and recommendations on diet, exercise, stress management, mental wellbeing, sleep and lifestyle – tailored to your needs.',
    needHealthCare: 'Need to seek medical advice?',
    gynocologistOfficeTitle: 'Gynaecology Clinic',
    gynocologistOfficeDescription:
      'Please note that in some regions, a referral is required to see a gynaecologist, whilst in other regions you can book an appointment directly. Visit 1177 for information about what applies where you live.',
    physicalClinicTitle: 'EsterCare Physical Clinic',
    physicalClinicDescription:
      'For an in-person appointment with a gynaecologist in Stockholm, you can book a time at our gynaecology clinic at Torsplan. You can do this by calling 08-60 90 270. Our clinic is affiliated with the regional healthcare system, which means you pay a patient fee of 275 kr; healthcare cards are accepted.',
    digitalClinicTitle: 'EsterCare Digital Clinic',
    digitalClinicDescription:
      'EsterCare Digital Clinic. You can book a virtual appointment with a gynaecologist via our EsterCare app. Our clinic is affiliated with the regional healthcare system, which means you pay a patient fee of 100 kr for a virtual appointment; healthcare cards are accepted.',

    learnMore: 'Learn more',
    yourOutcomes: 'Your outcomes',
    yourOutcomesDescription:
      'Based on your screening, we have identified the following outcomes that may be relevant to you.',
    yourWellbeingTitle: 'Your wellbeing over time',
    yourCheckList: 'Your checklist',
    translationsMissing1:
      'A translation for your Health Plan is currently incomplete or unavailable in your selected language. Please contact support for assistance.',
    translationsMissing2:
      'If you’ve recently changed your language settings, it may take a few minutes for all content to update. Try refreshing the page in a few minutes.',
    showLess: 'Show less',
    askUs: 'Chat with us',
    askUsHeader: 'Chat',
    askUsTitle: 'Your health team is here for you',
    askUsDescription:
      'Ask questions, share concerns, or get guidance on your health plan and wellbeing. No question is too small – we are here to support you.',
    askUsCta: 'Start a conversation',
    followUpUpdated: 'New recommendations!',
    followUpUpdatedDate: 'Updated after your {{date}} follow-up',
    followUpSummaryUpdated: 'We updated your analysis, read your new summary here',
    improvedInAreas_one: '{{count}} area improved',
    improvedInAreas_other: '{{count}} areas improved',
    areaStable_one: '{{count}} area stable',
    areaStable_other: '{{count}} areas stable',
    needsAttention_one: '{{count}} area needs attention',
    needsAttention_other: '{{count}} areas need attention',
    yourProgress: 'Your Progress',
    progressVs: 'vs. {{date}}',
    seeAllProgress: 'See all your progress, graphs and ratings here',
    symptomImproving: 'Improving',
    symptomStable: 'Stable',
    symptomNeedsAttention: 'Needs attention',
    symptomResolved: 'Resolved',
  },
  submitScreen: {
    followUpTitle: 'Submit follow-up',
    followUpSuccessTitle: 'Your follow-up has been submitted!',
    followUpInstructions: 'You have now answered all the questions and all that remains is to submit your follow-up.',
    followUpProcess:
      'What happens next? Our team will review your answers to assess how your wellbeing has developed and compile personalised recommendations based on your needs. Within 3 working days, you will receive an email notifying you that your analysis is ready.',
    checkInTitle: 'Submit check-in',
    checkInSuccessTitle: 'Your check-in has been submitted!',
    checkInInstructions: 'You have now completed your check-in. Submit your answers.',
    screeningTitle: 'Submit screening',
    screeningSuccessTitle: 'Your screening has been submitted!',
    screeningInstructions: 'You have now answered all the questions and all that remains is to submit your screening.',
    screeningProcess:
      "What happens next? Our health team will begin working on your personalised analysis and health plan. Within 3 working days, you will receive an email notifying you that your results are ready - we are confident you'll want to take the next step on your health journey!",
    endFollowUpNoBookingRequest:
      'Thank you for your answers! We will get back to you within three working days with updated advice and recommendations in your health plan. You can already follow how your health has developed over time in your health plan.',
    endFollowUpBookingRequest:
      'Thank you for your answers! We will get back to you within three working days with updated advice and recommendations in your health plan. Since you requested help booking a care appointment, you can send a booking request now. We will get back to you as soon as possible with a suggested time for either a physical or digital appointment.',
    endFollowUpPregnancyEnded:
      'Thank you for your answers! We can see that your situation has changed since you completed your screening last time. Would you like to redo your screening in full and get an updated health plan?',
    endCheckInNoBookingNoCall:
      'Thank you for your answers! This shorter check-in is now complete. We will get back to you when it is time for a more comprehensive follow-up of your well-being. You will then register your symptoms and receive new, updated recommendations. Would you like to speak with a midwife now? Book a free health call where you can ask questions and get advice, support and guidance about your health.',
    endCheckInNoBookingRequestHasCall:
      'Thank you for your answers! This shorter check-in is now complete. We will get back to you when it is time for a more comprehensive follow-up of your well-being. You will then register your symptoms and receive new, updated recommendations. Do you have any questions about your health plan or your well-being? You are warmly welcome to chat with one of our midwives to get quick answers to your questions.',
    endCheckInBookingRequest:
      'Thank you for your answers! This shorter check-in is now complete. We will get back to you when it is time for a more comprehensive follow-up of your well-being. You will then register your symptoms and receive new, updated recommendations. Since you requested help booking a care appointment, you can send a booking request now. We will get back to you as soon as possible with a suggested time for either a physical or digital appointment.',
    endStandardBookingRequest:
      'Thank you for your answers! Our health team will begin working on your personalised analysis and health plan. Within 3 working days, you will receive an email notifying you that your results are ready. Since you requested help booking a care appointment, you can send a booking request now. We will get back to you as soon as possible with a suggested time for either a physical or digital appointment.',
    endBookingRequestButton: 'Send care appointment request',
    endCheckInNoBookingNoCallButton: 'Book health call with a midwife',
    endStartConversationButton: 'Chat with a midwife',
    endFollowUpNoBookingRequestButton: 'See your health progress',
    endFollowUpPregnancyEndedButton: 'Start new screening',
    endTitle: 'Thank you for your answers!',
  },
  trainings: {
    title: 'Training',
    description:
      "Training in women's health is crucial for raising awareness about women's unique health needs. Through increased knowledge, we can reduce stigma, improve work environments and promote a more inclusive and healthy workplace.",
    completedMessage: 'You have completed the training',
  },
  support: {
    questionsTitle: 'Do you have other questions?',
    contactText: "Email support@estercare.com and we'll help you!",
  },
  messages: {
    title: 'Chat',
    startConversation: 'Start a new conversation',
    emptyTitle: 'Your health team is here for you',
    emptyDescription:
      'Ask questions, share concerns, or get guidance on your health plan and wellbeing. No question is too small, we are here to support you. Our health team usually replies within 24 hours on business days.',
    topicsLabel: 'Examples of topics you can discuss',
    topicDiet: 'Diet',
    topicSleep: 'Sleep',
    topicStress: 'Stress Management',
    topicMentalHealth: 'Mental Well-being',
    topicOutcomes: 'Health plan outcomes',
    topicDetails: 'Health plan details',
    topicSelfCare: 'Self-Care',
    messageLabel: 'Your message',
    messagePlaceholder: 'Describe your questions or concerns...',
    bookingRequestTemplate:
      'Hi, I would like help booking a care appointment after completing the screening.\n\nMy personal identity number: \nMy phone number: ',
    sendButton: 'Send your message',
    replyTime:
      'Your questions are handled confidentially and answered by licensed healthcare professionals. We usually reply within 24 hours on business days.',
    healthTeam: 'EsterCare Health Team',
    responseInfo:
      'Licensed healthcare professionals will answer you within 24 hours. You will receive an email notification.',
    writeMessage: 'Write your message...',
    tableHeaderId: 'Message',
    tableHeaderStatus: 'Status',
    tableHeaderLastMessageDate: 'Last update',
    closedCase: 'Closed',
    relativeTimeJustNow: 'Just now',
    relativeTimeMinutesAgo: 'm ago',
    relativeTimeHoursAgo: 'h ago',
    relativeTimeYesterday: 'Yesterday',
    relativeTimeDaysAgo: 'days ago',
    fallbackSender: 'You:',
    selectConversationFooter: 'Have questions about EsterCare? Check out our <highlight>FAQ for answers</highlight>.',
    createError: 'Something went wrong, please try again later.',
    conversationClosedTitle: 'This conversation has been closed.',
    conversationClosedDescription: 'If you have more questions or concerns, feel free to start a new one.',
  },
  knowledgeBank: {
    articlesCount: 'Articles ({{count}})',
    podcastsCount: 'Podcast episodes ({{count}})',
    allPodcasts: 'All podcast episodes',
    allArticles: 'All articles',
    episodeTitle: 'Episode {{episodeNumber}}: {{title}}',
    aboutEpisode: 'About the episode',
    relatedPodcasts: 'Related podcasts',
    relatedArticles: 'Related articles',
    swedishOnly: 'This podcast episode is in Swedish.',
  },
} as const
